import styled from 'styled-components';

export const IncomeTaxesStyles = styled.div`
  background-color: #F5F5F7;

  .faqs .container .row {
    background: none;
  }

  .jumbotron {
    ${props => props.theme.media.lg} {
      bottom: 50px;
    }

    .row {
      margin-right: 0px;
      margin-left: 0px;
    }

    .btn-wrap {
      position: absolute;
      bottom: 7rem;
      z-index: 1;
      left: 50%;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
  
      ${props => props.theme.media.lg} {
        bottom: auto;
        left: auto;
        position: relative;
        -webkit-transform: none;
        transform: none;
      }
  
      .btn-hero-cta {
        border-radius: 2rem;
        color: #fff;
        cursor: pointer;
        display: inline-flex;
        font-size: 14px;
        margin-top: 1.5rem;
        padding: 0.7em 3.5em 0.7em 1.5em;
        position: relative;
        box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);
        transition: 0.2s box-shadow ease-in-out;
  
        ${props => props.theme.media.sm} {
          font-size: 1.5rem;
          margin-top: 1.5rem;
        }
  
        &:hover {
          box-shadow: 0 0 15px rgba(241, 89, 1, 0.5);
        }
  
        .btn-icon {
          align-items: center;
          background: ${props => props.theme.secondary};
          border-radius: 50%;
          display: grid;
          height: 48px;
          margin: 0;
          padding: 9px;
          position: absolute;
          right: -1px;
          width: 48px;
  
          ${props => props.theme.media.lg} {
            height: 59px;
            width: 59px;
          }
        }
      }
    }
  }

  .income-taxes-header {
    height: 600px;
    
    ${props => props.theme.media.lg} {
      padding-top: 50px;
      margin-top: 50px;
    }

    .container {
      ${props => props.theme.media.lg} {
        margin-top: 50px;
      }
    }

    h1 {
      color: #3F5261;
      font-size: 40px;
      font-weight: 500;
      max-width: 304px;
      width: 100%;
      line-height: 46px;
      margin: auto;

      ${props => props.theme.media.lg} {
        font-size: 50px;
        max-width: 586px;
      }
    }

    .sub-header {
      max-width: 315px;
      width: 100%;
      margin: auto;
      margin-top: 40px;

      ${props => props.theme.media.lg} {
        max-width: 522px;
      }
      
      p {
        font-family: Poppins;
        font-size: 20px;
        color: #3F5261;
        margin: auto; 
        line-height: 26px;
        font-weight: 350;

        ${props => props.theme.media.lg} {

        }
      }
    }

    .btn {
      height: 70px;
      max-width: 360px;
      width: 100%;
      font-size: 30px;
      margin-top: 38px;
      font-weight: 350;
      background-color: #FF6712;
      font-size: 24px;

      ${props => props.theme.media.lg} {
        font-size: 24px;
        height: 63px;
        max-width: 436px;
      }
    }
  }

  .trust-pilot-container {
    ${props => props.theme.media.lg} {
      margin-top: -50px;
    }
  }

  section.features-container {
    h2 {
      width: 100%;
      max-width: 300px;
      margin: auto;
      margin-bottom: 30px;
      
      ${props => props.theme.media.lg} {
        max-width: 100%;
      }
    }

    .subtitle {
      ${props => props.theme.media.lg} {
        max-width: 641px;
      }
    }
    
    
    .features-list {
      .content {
        p {
          max-width: 325px;
          width: 100%;
          margin: auto;
          text-align: left;
          line-height: 24px;

        }
      }
    }
    
    .feature:first-child {
      .content {
        p {
          font-size: 14px;

          ${props => props.theme.media.lg} {
            font-size: 15px;
            max-width: 340px;
          }
        }
      }
    }
  }

  section.about-services {
    .subtitle {
      p {
        font-weight: 350;
      }
    }
  }

  .happy-to-help {
    ${props => props.theme.media.lg} {
      background-color: #F8F6F4;
    }

    .mobile {
      ${props => props.theme.media.lg} {
        display: none;
      }
    }

    .desktop {
      display: none;
      ${props => props.theme.media.lg} {
        display: block;
      }
    }

    .happy-title {
      font-family: Poppins;
      font-size: 30px;
      line-height: 30px;
      font-weight: 500;
      text-align: center;
      max-width: 325px;
      width: 100%;
      margin: auto;
      margin-bottom: 20px;

      ${props => props.theme.media.lg} {
        max-width: 100%;
        font-size: 40px;
      }
    }


    .happy-subtitle {
      font-family: Inter;
      font-size: 16px;
      font-weight: 350;
      line-height: 24px;
      text-align: center;
      max-width: 325px;
      width: 100%;
      margin: auto;
      margin-bottom: 40px;
      ${props => props.theme.media.lg} {
        max-width: 641px;
        text-align: left;
      }
    }

    .title {
      font-family: Poppins;
      font-size: 30px;
      font-weight: 500px;
    }

    .subtitle {
      p {
        max-width: 325px;
        width: 100%;
        font-weight: 350;
        font-size: 16px;
        line-height: 24px;
        ${props => props.theme.media.lg} {
          max-width: 461px;
        }
      }
    }

    .index-0 {
      .subtitle {
        p {
          ${props => props.theme.media.lg} {
            max-width: 441px;
          }
        }
      }
    }

    .img-wrapper {
      .mb-3 {
        ${props => props.theme.media.lg} {
          width: 504px;
        }
      }
    }
  }

  section.cta-list {
    background-color: #F5F5F7;
    padding-top: 0px;

    .content {
      ${props => props.theme.media.lg} {
        margin-top: 100px;
      }

      h2 {
        text-align: center;
        max-width: 290px;
        width: 100%;
        margin: auto;
        margin-bottom: 20px;

        ${props => props.theme.media.lg} {
          text-align: left;
          max-width: 100%;
        }
      }
    }

    .ctalist-container {
      background: #F5F5F7;

      button {
        display: none;
      }

      li {
        color: #3F5261 !important;
        text-align: center;
        padding-right: 50px;
        max-width: 380px;
        width: 100%;
        margin: auto;
        font-size: 26px !important;
        margin-top: 100px;

        ${props => props.theme.media.lg} {
          text-align: left;
          width: 100%;
          max-width: 630px;
          line-height: 39px;
          margin-top: 0px;
        }
        &::before {
          left: 45% !important;
          top: -35px !important;
          ${props => props.theme.media.lg} {
            left: 0 !important;
            top: -2px !important;
          }
        }
      }
    }
  }

  section.faqs {
    margin-top: -80px;
    background-color: #F5F5F7;

    ${props => props.theme.media.xl} {
      margin-top: -165px;
    }

    padding-left: 1.5rem;
    padding-right: 1.5rem;

    ${(props) => props.theme.media.md} {
      padding-left: 0;
      padding-right: 0;
    }



    .row:nth-child(2) {
      border-top: 1px solid ${(props) => props.theme.gray300};
    }
  }

  section.learn-more-blogs {
    background-color: #F5F5F7;
    h2 {
      font-size: 30px;
      font-weight: 400;
      color: #505050;
      line-height: 30px;
      ${props => props.theme.media.xl} {
        font-size: 40px;
        margin-bottom: 20px;

      }
    }
    .section-subtitle {
      display: block;
      font-family: Poppins;
      font-size: 18px;
      line-height: 22px;
      font-weight: 350;
      width: 100%;
      max-width: 352px;
      margin: auto;
      margin-bottom: 20px;
      letter-spacing: 0px;
      ${props => props.theme.media.xl} {
        max-width: 670px;
        margin-bottom: 60px;
      }
    }

    .product-img {
      width: 100%;
      ${props => props.theme.media.xl} {
        max-width: 309px;
        margin: auto;
      }
    }

    .copy {
      .product-title {
        text-align: center !important;
        color: #3F5261 !important;
        ${props => props.theme.media.xl} {
  
        }
      }

      .text-center {
        color: #F15F22 !important;
        text-align: center !important;
        ${props => props.theme.media.xl} {
        } 
      }

      .text-center::after {
        display: none;
      }

      .product-description {
        font-weight: 350;
        line-height: 21px !important;
        width: 319px !important;
        ${props => props.theme.media.md} {
          width: auto !important;
        }
        ${props => props.theme.media.xl} {
          width: 319px !important;
        }
      }
    }

    .product:nth-child(2) {
      .copy {
        .product-title {
          margin: auto;
          width: 100%;
          margin-top: 1rem;
          margin-bottom: 0.5rem;
        }
      }
    }

    .product:nth-child(3) {
      .copy {
        .product-title {
          width: 100%;
          margin: auto;
          margin-top: 1rem;
          margin-bottom: 0.5rem;
        }
      }
    }
  }
`;